import React from "react";
import PropTypes from "prop-types";
import { IconButton, Box, Link } from "@mui/material";
import { Fullscreen, SaveAlt } from "@mui/icons-material";
import PrintButton from "../Buttons/PrintButton";
import { isPrintable, printContent } from "../../utils/print_service";

function ContentViewerActionButtons(props) {
  const {
    downloadLink,
    contentType,
    fileType,
    onFullScreenChange,
    fullScreen,
    allowFullScreen
  } = props;

  const onPrintContent = () => {
    printContent(downloadLink, fileType);
  };
  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end">
      {allowFullScreen && (
        <IconButton
          onClick={() => onFullScreenChange(!fullScreen)}
          size="large"
        >
          <Fullscreen color="primary" />
        </IconButton>
      )}
      {contentType === "file" && (
        <Link href={downloadLink}>
          <IconButton size="large">
            <SaveAlt color="primary" />
          </IconButton>
        </Link>
      )}
      {isPrintable(fileType) && (
        <PrintButton outlined onButtonClick={onPrintContent} />
      )}
    </Box>
  );
}

export default ContentViewerActionButtons;

ContentViewerActionButtons.propTypes = {
  contentLink: PropTypes.string,
  contentType: PropTypes.string,
  fileType: PropTypes.string,
  downloadLink: PropTypes.string,
  navigationButtons: PropTypes.node
};
